module.exports = __webpack_public_path__ + "static/media/lady-of-the-moon.71daaa15.gif";